import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import customerService from 'api/customer.service';
import partnerService from 'api/partner.service';
import warehouseService from 'api/warehouse.service';
import { get } from 'lodash';
import { displayAppLoading } from 'reducers/app/app.reducer';

interface ISetState {
  dataList?: Customer;
  isLoading?: boolean;
}

interface IQueryError {
  message: string;
}

export interface CustomerState {
  dataList?: any;
  isLoading: boolean;
  errors?: string[];
  customers: any;
  pcustomers: any;
  staffList: any;
  partners: any;
  selectedTab?: string;
}

const initialState: CustomerState = {
  isLoading: false,
  errors: null,
  dataList: [],
  customers: [],
  pcustomers: [],
  staffList: [],
  partners: [],
  selectedTab: 'tab1',
};

const slice = createSlice({
  name: 'customers',
  initialState: initialState,
  reducers: {
    setState(state: CustomerState, { payload }: PayloadAction<ISetState>) {
      state.isLoading = payload.isLoading;
      if (payload.dataList) {
        state.dataList = payload.dataList;
      }
    },
    onFetchCustomersSuccess(
      state: CustomerState,
      { payload }: PayloadAction<Customer[]>
    ) {
      state.customers = payload;
    },
    onFetchPCustomersSuccess(
      state: CustomerState,
      { payload }: PayloadAction<Customer[]>
    ) {
      state.pcustomers = payload;
    },
    onFetchPartnerSuccess(
      state: CustomerState,
      { payload }: PayloadAction<Customer[]>
    ) {
      state.partners = payload;
    },
    onFetchStaffSuccess(
      state: CustomerState,
      { payload }: PayloadAction<Customer[]>
    ) {
      state.staffList = payload;
    },
    updateSelectedTab(
      state: CustomerState,
      { payload }: PayloadAction<string>
    ) {
      state.selectedTab = payload;
    },
  },
});

export const {
  setState,
  onFetchCustomersSuccess,
  updateSelectedTab,
  onFetchPCustomersSuccess,
  onFetchPartnerSuccess,
  onFetchStaffSuccess,
} = slice.actions;

export default slice.reducer;

export const fetchCustomers = (params) => async (dispatch) => {
  try {
    dispatch(setState({ isLoading: true }));
    if (params.p_cus_id === -1) {
      delete params.p_cus_id;
    }
    const response = await customerService.findParams(params);
    const transformedResponseData = get(response, 'data', []);
    dispatch(onFetchCustomersSuccess(transformedResponseData));
  } catch (err) {
    console.error('Error', err);
  } finally {
    dispatch(setState({ isLoading: false }));
  }
};

export const fetchStaff = (params) => async (dispatch) => {
  try {
    dispatch(setState({ isLoading: true }));
    // if (params.p_cus_id === -1) {
    //   delete params.p_cus_id;
    // }
    const response = await warehouseService.fetchWarehousemanList(params);
    const transformedResponseData = get(response.data, 'warehouseman', []);
    dispatch(onFetchStaffSuccess(transformedResponseData));
  } catch (err) {
    console.error('Error', err);
  } finally {
    dispatch(setState({ isLoading: false }));
  }
};

export const fetchPCustomers = (params) => async (dispatch) => {
  try {
    dispatch(setState({ isLoading: true }));
    const response = await customerService.getPcustomer(params);
    const transformedResponseData = get(response, 'data', []);
    dispatch(onFetchPCustomersSuccess(transformedResponseData));
  } catch (err) {
    console.error('Error', err);
  } finally {
    dispatch(setState({ isLoading: false }));
  }
};

export const fetchPartner = (params) => async (dispatch) => {
  try {
    dispatch(setState({ isLoading: true }));
    const response = await partnerService.find(params);
    const transformedResponseData = get(response.data, 'dataList', []);
    dispatch(onFetchPartnerSuccess(transformedResponseData));
  } catch (err) {
    console.error('Error', err);
  } finally {
    dispatch(setState({ isLoading: false }));
  }
};
